<template>
  <SidebarShell :model="model" />
</template>

<script setup lang="ts">
import { watch } from 'vue'

import { usePlatformStore } from '@/shared/stores/platform'
import { useDevice } from '@/shared/composables/useDevice'
import SidebarShell from './sidebar/SidebarShell.vue'
import { useSidebarModel } from './sidebar/useSidebarModel'

const { model, selectedItems } = useSidebarModel()
const platformStore = usePlatformStore()
const device = useDevice()

if (device.isTabletHorizontal.value) {
  platformStore.setSidebarCollapse(true)
}

watch(selectedItems, () => {
  if (document.body.style.pointerEvents === 'none' || device.isDesktop.value) {
    return
  }
  platformStore.setSidebarCollapse(!selectedItems.value.length)
})
</script>
